import React, { useId } from 'react';

const FormTextarea = ({ label, name, value, onChange, onKeyDown, placeholder, rows = 4, ...rest }) => {
    const reactId = useId();
    const fieldId = `${reactId}-${name}`;
    return (
        <div>
            <label htmlFor={fieldId} className="block text-xs font-bold text-gray-400 uppercase mb-2">
                {label}
            </label>
            <textarea
                id={fieldId}
                name={name}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                rows={rows}
                className="w-full bg-[#0f172a] border border-gray-600 rounded-md p-3 focus:ring-blue-500 focus:border-blue-500 leading-relaxed"
                {...rest}
            />
        </div>
    );
};

export default FormTextarea;
